/**
 * Created by tigran on 18.01.25
 **/

import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const MonitoringIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 64 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M48.4115 43.5265C49.3172 43.5265 50.0515 42.7922 50.0515 41.8865C50.0515 40.9807 49.3172 40.2465 48.4115 40.2465C47.5057 40.2465 46.7715 40.9807 46.7715 41.8865C46.7715 42.7922 47.5057 43.5265 48.4115 43.5265Z"
          fill={color}
        />
        <path
          d="M40.2109 41.8865C40.2109 37.3576 43.8821 33.6865 48.4109 33.6865C52.9398 33.6865 56.6109 37.3576 56.6109 41.8865C56.6109 46.909 48.4109 55.0065 48.4109 55.0065C48.4109 55.0065 40.2109 46.909 40.2109 41.8865Z"
          stroke={color}
          strokeWidth={1.968}
          strokeMiterlimit={10}
          strokeLinecap="round"
        />
        <path
          d="M12.3203 36.9465L12.3203 13.9865C12.3203 12.1751 13.7889 10.7065 15.6003 10.7065L48.4003 10.7065C50.2117 10.7065 51.6803 12.1751 51.6803 13.9865L51.6803 28.7465"
          stroke={color}
          strokeWidth={1.968}
          strokeMiterlimit={10}
          strokeLinecap="round"
        />
        <path
          d="M30.3613 15.6264H33.6413"
          stroke={color}
          strokeWidth={1.968}
          strokeMiterlimit={10}
          strokeLinecap="square"
        />
        <path
          d="M34.4506 41.8865L7.39062 41.8865C7.39062 45.5092 10.3279 48.4465 13.9506 48.4465L36.0906 48.4465"
          stroke={color}
          strokeWidth={1.968}
          strokeMiterlimit={10}
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
};
